import { render, staticRenderFns } from "./FileEditorComponent.vue?vue&type=template&id=9d461fae&scoped=true&"
import script from "./FileEditorComponent.vue?vue&type=script&lang=ts&"
export * from "./FileEditorComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FileEditorComponent.vue?vue&type=style&index=0&id=9d461fae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d461fae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VMessages } from 'vuetify/lib/components/VMessages';
installComponents(component, {VChip,VIcon,VLabel,VMessages})
